import { NgModule } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NativeDateAdapter } from "@angular/material";
import * as moment from 'moment';
import {MatButtonModule, 
       MatCheckboxModule,
       MatDatepickerModule,
       MatFormFieldModule,
       MatNativeDateModule,
       MatAutocompleteModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatButtonToggleModule,
        MatCardModule,
        MatChipsModule,
        MatDialogModule,
        MAT_DIALOG_DEFAULT_OPTIONS,
        MatDividerModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatTreeModule
      } from '@angular/material';

const matmodules = [
                    FormsModule,
                    ReactiveFormsModule,
                    MatButtonModule, 
                    MatCheckboxModule,
                    MatDatepickerModule,
                    MatFormFieldModule,
                    MatNativeDateModule,
                    MatAutocompleteModule,
                    MatBadgeModule,
                    MatBottomSheetModule,
                    MatButtonToggleModule,
                    MatCardModule,
                    MatChipsModule,
                    MatDialogModule,
                    MatDividerModule,
                    MatExpansionModule,
                    MatGridListModule,
                    MatIconModule,
                    MatInputModule,
                    MatListModule,
                    MatMenuModule,
                    MatPaginatorModule,
                    MatProgressBarModule,
                    MatProgressSpinnerModule,
                    MatRadioModule,
                    MatRippleModule,
                    MatSelectModule,
                    MatSidenavModule,
                    MatSliderModule,
                    MatSlideToggleModule,
                    MatSnackBarModule,
                    MatSortModule,
                    MatStepperModule,
                    MatTableModule,
                    MatTabsModule,
                    MatToolbarModule,
                    MatTooltipModule,
                    MatTreeModule
                  ];

                  export class CustomDateAdapter extends NativeDateAdapter {
                    format(date: Date, displayFormat: Object): string {
                        var formatString = (displayFormat === 'input')? 'DD.MM.YYYY' : 'LLL';
                        return moment(date).format(formatString);
                    }
                }


@NgModule({
  imports: matmodules,
  exports: matmodules,
  providers: [
    {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {hasBackdrop: true, direction: 'ltr'}}
  ]
})
export class AppMaterialModule { }
